// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"5a4cb902","112":"21ce435e"}[chunkId] + ".chunk.css";
};